import { Injectable } from '@angular/core';
import { Functions, httpsCallable } from '@angular/fire/functions';
import { environment } from 'src/environments/environment';

export interface Card {
  id?: string;
  code: string;
  points: string;
}

export interface CardResponse {
  cards: Card[];
  count: number;
  success: boolean;
}
@Injectable({
  providedIn: 'root',
})
export class OdooFidelityService {
  constructor(private functions: Functions) {}

  async getCards() {
    const callable = httpsCallable<{ isProd: boolean }, CardResponse>(
      this.functions,
      'get_cards'
    );
    return callable({ isProd: environment.production });
  }
  async addCard(card: Card) {
    const callable = httpsCallable<{ card: Card; isProd: boolean }, void>(
      this.functions,
      'add_card'
    );
    return callable({ card, isProd: environment.production });
  }
}
